import { Component, OnInit, Input } from '@angular/core';
import { AllowancesService } from 'src/app/shared/services/allowances.service';
import { AddAllowanceComponent } from './add-allowance/add-allowance.component';
import { faTimes, faPlus } from '@fortawesome/pro-light-svg-icons';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-allowance',
  templateUrl: './allowance.component.html',
  styleUrls: ['./allowance.component.scss']
})
export class AllowanceComponent implements OnInit {

  @Input() caseId: number;
  public allowances: any[];

  faTimes = faTimes;
  faPlus = faPlus;

  constructor(
  private allowancesService: AllowancesService, 
  public modalService: ModalService) { 

    this.allowances = [];
  }

  ngOnInit(): void {
    this.getAllowances();
  }

  openAddAllowance() {


    const modalRef = this.modalService.openWithOptions(AddAllowanceComponent, {size: 'md'});
         
    modalRef.componentInstance.caseId = this.caseId;

      modalRef.result.then(
        (result) => {
          if(result)
          {
            this.getAllowances();
          }
        },
      () => {} // dismissed - do nothing
    );
  }

  getAllowances() {
    this.allowancesService.getAllowances(this.caseId).subscribe((response:any) => {
      this.allowances = response;
    });
  }

  deleteAllowance(allowanceId: number) {
    this.allowancesService.deleteAllowance(this.caseId, allowanceId).subscribe(() => {
      this.getAllowances();
    });
  }


}
